/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWaitlistSignup = /* GraphQL */ `
  mutation CreateWaitlistSignup(
    $input: CreateWaitlistSignupInput!
    $condition: ModelWaitlistSignupConditionInput
  ) {
    createWaitlistSignup(input: $input, condition: $condition) {
      id
      name
      email
      source
      createdAt
      updatedAt
    }
  }
`;
export const updateWaitlistSignup = /* GraphQL */ `
  mutation UpdateWaitlistSignup(
    $input: UpdateWaitlistSignupInput!
    $condition: ModelWaitlistSignupConditionInput
  ) {
    updateWaitlistSignup(input: $input, condition: $condition) {
      id
      name
      email
      source
      createdAt
      updatedAt
    }
  }
`;
export const deleteWaitlistSignup = /* GraphQL */ `
  mutation DeleteWaitlistSignup(
    $input: DeleteWaitlistSignupInput!
    $condition: ModelWaitlistSignupConditionInput
  ) {
    deleteWaitlistSignup(input: $input, condition: $condition) {
      id
      name
      email
      source
      createdAt
      updatedAt
    }
  }
`;
